var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item",on:{"click":_vm.onToDetail}},[_c('van-image',{attrs:{"width":"100%","src":_vm.good.image}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }